import React from "react";
import useStyles from "./styles";
import { LineChartProps } from "./types";
import { Line } from "react-chartjs-2";
import {
  Card,
  CardHeader,
  Avatar,
  CardContent,
  CircularProgress
} from "@material-ui/core";
import { ShowChart, ZoomIn } from "@material-ui/icons";
import { getRandomColor } from "../../shared/graphFunctions";

const LineChart = ({
  title,
  chartData,
  targetLines,
  isLoading,
  pointRadius,
  tension,
  border,
  options
}: LineChartProps) => {
  const classes = useStyles();

  return (
    <Card>
      <CardHeader
        title={title}
        className={classes.header}
        avatar={
          <Avatar aria-label={title} className={classes.avatar}>
            <ShowChart />
          </Avatar>
        }
        /*action={
                    <IconButton aria-label="zoom">
                      <ZoomIn/>
                    </IconButton>
                  }*/
      />
      <CardContent className={classes.container}>
        <Line
          type={Line}
          options={
            options
              ? options
              : {
                  scales: {
                    x: {
                      ticks: {
                        autoSkip: true,
                        maxTicksLimit: 20
                      }
                    }
                  },
                  plugins: {
                    annotation: {
                      annotations: !targetLines
                        ? {}
                        : targetLines.map(t => {
                            return {
                              drawTime: "beforeDraw",
                              type: "line",
                              borderColor: `rgb(${t.rgbColor.r}, ${t.rgbColor.g}, ${t.rgbColor.b})`,
                              borderWidth: 2,
                              value: t.value,
                              scaleID: "y",
                              label: {
                                content: t.title,
                                enabled: true,
                                position: "end",
                                backgroundColor: "rgb(105,105,105)"
                              }
                            };
                          })
                    }
                  }
                }
          }
          data={{
            labels: chartData.labels,
            datasets: chartData.datasets.map(d => {
              let color = getRandomColor();
              return {
                label: d.label,
                backgroundColor: d.rgbColor
                  ? `rgba(${d.rgbColor.r},${d.rgbColor.g},${d.rgbColor.b}, 0.4)`
                  : color,
                borderColor: d.rgbColor
                  ? `rgb(${d.rgbColor.r},${d.rgbColor.g},${d.rgbColor.b})`
                  : color,
                pointRadius: pointRadius ? pointRadius : 1,
                tension: tension ? tension : 0.4,
                borderWidth: border ? border : 3,
                fill: false,
                data: d.data
              };
            })
          }}
        />
        {!isLoading ? (
          <></>
        ) : (
          <div className={classes.spinnerContainer}>
            <CircularProgress />
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default LineChart;
